import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	FormHelperText,
} from '@material-ui/core';

import { useTranslation } from '@common/utils';
function FormSelect({ label, options, touched, props, setFieldValue, prop, required, errors, handleBlur }) {
	const classes = useStyles();
	const tr = useTranslation();
	const { value } = props || {};

	return (
		<FormControl error={(Boolean(touched[prop]) && Boolean(errors[prop]))} fullWidth variant="outlined" >
			<InputLabel required={required} className={classes.label} >{tr(label)}</InputLabel>
			<Select
				label={tr(label)}
				value={value}
				onChange={(e) => setFieldValue(prop, e.target.value, true)}
				onBlur={handleBlur(prop)}
			>
				{(options ?? []).map((option, i) => {
					return (
						<MenuItem key={i} value={option.value}>
							{tr(option.label)}
						</MenuItem>
					);
				})}
			</Select>
			{(Boolean(touched[prop]) && Boolean(errors[prop])) && (
				<FormHelperText style={{ marginLeft: '14px' }} error={true}>
					{errors[prop]}
				</FormHelperText>
			)}
		</FormControl>
	);
}

FormSelect.propTypes = {
	label: PropTypes.string,
	options: PropTypes.array.isRequired,
	props: PropTypes.object,
	prop: PropTypes.string.isRequired,
	value: PropTypes.string,
	setFieldValue: PropTypes.func,
	helperText: PropTypes.string,
	required: PropTypes.bool,
	errors: PropTypes.object,
	touched: PropTypes.object,
	handleBlur: PropTypes.func,
};

export default FormSelect;

const useStyles = makeStyles(theme => ({
	label: {
		background: theme.palette.common.white,
	},
	icon: {
		color: 'rgba(0, 0, 0, 0.54)',
		marginRight: '8px',
	},
}));
